__turbopack_context__.v({
  "action": "EOcOWW_action",
  "card": "EOcOWW_card",
  "content": "EOcOWW_content",
  "imageItem": "EOcOWW_imageItem",
});
